import { useDispatch, useSelector } from 'react-redux';
import FadeIn from 'react-fade-in';

import cx from 'classnames';

export default function InputCheckboxGrid(props){
	const {
		type,
		choices,
		index,
	} = props;
	const selection = useSelector( s => s.questions[index].selection )
	const dispatch = useDispatch();
	const rootId = useSelector( s => s.rootId );

	return <FadeIn className="checkbox-grid-choices" wrapperTag="ul"
		childClassName="checkbox-grid-choice" childTag="li"
		delay="30"
		transitionDuration="600" >
		{ choices.map( (c,choice_index) => {
			const choiceId = `${ rootId }-question-${ index }-choice-${ choice_index }`;
			return <div className="checkbox-grid-choice-inner" key={ `${ index }-${ choice_index }` } >
				<input
					checked={ selection.indexOf(choice_index) !== -1 }
					type="checkbox"
					id={ choiceId }
					name={ choiceId }
					value={ c.value }
					onChange={ e => {
						var nextSelection;
						if ( e.target.checked ){
							nextSelection = [...selection, choice_index ].sort();
						} else {
							nextSelection = selection.filter( (i) => i !== choice_index );
						}
						dispatch({
							type: 'set/questionSelection',
							payload: {
								question: index,
								selection: nextSelection
							}
						})
					}}
				/>
				<label htmlFor={ choiceId } >
					{ c.text }
				</label>
			</div>
		} ) }
	</FadeIn>
}
